"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const React = require("react");
const react_redux_1 = require("react-redux");
const src_1 = require("@rover/ts-bootstrap/dist/src");
const WizardModal_1 = require("../wizards/WizardModal");
const reducers_1 = require("../../reducers");
const actions_1 = require("../../actions");
const ScheduledDelivery = ({ campaignId, device, saveAndClose, children, closeWizardModal, createEditableCampaign, isWizardModalClosing, showSaveAndClose, }) => {
    const animation = isWizardModalClosing ? 'close' : 'open';
    const getSaveAndCloseButton = () => {
        if (!showSaveAndClose) {
            return React.createElement("div", null);
        }
        return (React.createElement(src_1.Button, { onClick: () => {
                saveAndClose();
                closeWizardModal();
            }, size: "large", text: "Save & Close", type: "regular" }));
    };
    const getCancelButton = () => {
        return (React.createElement(src_1.Button, { onClick: () => {
                closeWizardModal();
                createEditableCampaign(campaignId);
            }, size: "large", text: "Cancel", type: "regular" }));
    };
    const wizardProps = {
        device,
        rightHeaderElement: getSaveAndCloseButton(),
        leftHeaderElement: getCancelButton(),
    };
    return (React.createElement("div", { style: {
            width: '100%',
            height: '100%',
            position: 'absolute',
            top: 0,
            left: 0,
            background: src_1.white,
            animation: `${animation} 500ms ease`,
        }, id: "scheduledSettingsForm" },
        React.createElement(WizardModal_1.default, Object.assign({}, wizardProps),
            React.createElement("div", { style: {
                    zIndex: 5,
                    position: 'absolute',
                    top: 0,
                    left: 0,
                    height: '100%',
                    width: '100%',
                    backgroundColor: src_1.white,
                    overflowY: 'scroll',
                } }, children))));
};
const mapStateToProps = (state) => ({
    isWizardModalClosing: reducers_1.getIsWizardModalClosing(state),
    showSaveAndClose: reducers_1.getShouldShowSaveAndClose(state),
});
const mapDispatchToProps = (dispatch) => {
    return {
        createEditableCampaign: (campaignId) => dispatch(actions_1.createEditableCampaign(campaignId)),
        closeWizardModal: () => dispatch(actions_1.closeWizardModal()),
    };
};
exports.default = react_redux_1.connect(mapStateToProps, mapDispatchToProps)(ScheduledDelivery);
